module.exports = __webpack_public_path__ + "img/InfoCircle.3cd9f98d.svg";